import BaseFormItem from "../BaseFormItem";
import React from "react";
import Control from "lib/common/descriptorcontrols/DateTimeField/label";

export class DateTimeFieldlabel extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        value={activeRecord.get(descriptor.key)}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)}
        />;
    }
}

export default DateTimeFieldlabel;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/DateTimeField/label.js